<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import IconRegenerate from '@/presentation/components/icons/IconRegenerate.vue';

const { t } = useI18n();

withDefaults(defineProps<{
    desc?: string;
}>(), {
    desc: '',
});
</script>

<template>
    <button
        class="lab-border-rounded-lg th-btn th-btn-text absolute bottom-10 !pl-5 !pr-[28px]"
        data-size="lg"
    >
        <IconRegenerate
            class="th-btn-icon mr-1 h-6 w-6 fill-primary"
        />

        {{ desc || t('aiTranslation.regenerate') }}
    </button>
</template>
